import { BsCheck2Circle } from 'react-icons/bs'

export const Check2CircleIcon = (props: any) => <BsCheck2Circle {...props} />
